import React, { useRef, useEffect, useState } from 'react';
import { Group, Image } from 'react-konva';
import useImage from 'use-image';
import Konva from 'konva';
const MovableImage = React.memo(({ imageIndex, imageData, blackWhiteEffect, canvasMultiplier, canvasScaler, currentDraggedIndex, containerRef, updateImageDimensions, isSelected, onSelect, onInteract, imageRef, }) => {
    const uploadedImageRef = useRef(null);
    const [canvasImage, setCanvasImage] = useState(null);
    const [placeholderImage] = useImage(imageData.placeholder, 'anonymous');
    const [imageLoaded, setImageLoaded] = useState(false);
    useEffect(() => {
        let attempts = 0;
        const loadImageWithRetry = () => {
            if (attempts >= 3)
                return; // Stop retrying after 3 failed attempts
            console.log(`Attempt ${attempts + 1}: Loading ${imageData.uploadedImage}`);
            const img = new window.Image();
            img.crossOrigin = 'anonymous';
            img.src = imageData.uploadedImage;
            img.onload = () => {
                console.log(`Image Loaded Successfully: ${imageData.uploadedImage}`);
                setCanvasImage(img);
                setImageLoaded(true);
            };
            img.onerror = () => {
                console.error(`Image failed to load (Attempt ${attempts + 1}): ${imageData.uploadedImage}`);
                attempts++;
                setTimeout(loadImageWithRetry, 500); // Retry after 500ms
            };
        };
        if (imageData.uploadedImage) {
            loadImageWithRetry();
        }
    }, [imageData.uploadedImage]);
    // Apply grayscale filter when blackWhiteEffect changes
    useEffect(() => {
        var _a;
        if (uploadedImageRef.current) {
            if (blackWhiteEffect) {
                uploadedImageRef.current.filters([Konva.Filters.Grayscale]);
                uploadedImageRef.current.cache();
            }
            else {
                uploadedImageRef.current.filters([]);
                uploadedImageRef.current.cache();
            }
            (_a = uploadedImageRef.current.getLayer()) === null || _a === void 0 ? void 0 : _a.batchDraw();
        }
    }, [blackWhiteEffect, imageLoaded]);
    if (imageData.loading && placeholderImage != null) {
        return (React.createElement(Image, { image: placeholderImage, width: imageData.position.width * canvasScaler, height: imageData.position.height * canvasScaler, x: imageData.position.pos_x * canvasScaler, y: imageData.position.pos_y * canvasScaler, rotation: imageData.position.rotation }));
    }
    if (!imageLoaded || !canvasImage)
        return null;
    return (React.createElement(Group, { ref: imageRef }, imageData.uploadedImage != null ? (React.createElement(React.Fragment, null,
        React.createElement(Image, { width: imageData.position.width * canvasScaler, height: imageData.position.height * canvasScaler, x: imageData.position.pos_x * canvasScaler, y: imageData.position.pos_y * canvasScaler, rotation: imageData.position.rotation, offsetY: (imageData.position.height * canvasScaler) / 2, offsetX: (imageData.position.width * canvasScaler) / 2, image: canvasImage, ref: (node) => {
                uploadedImageRef.current = node;
                // Also set the imageRef to point to the Image node for transformer
                if (imageRef.current) {
                    imageRef.current.imageNode = node;
                }
            }, onClick: onSelect, onTap: onSelect, draggable: true, fill: "transparent", onDragStart: onInteract, onDragEnd: (e) => {
                const node = uploadedImageRef.current;
                if (node) {
                    const scaleX = node.scaleX();
                    const scaleY = node.scaleY();
                    node.scaleX(1);
                    node.scaleY(1);
                    const dimensions = {
                        height: Math.max(node.height() * scaleY) * canvasMultiplier,
                        width: Math.max(5, node.width() * scaleX) * canvasMultiplier,
                        pos_x: e.target.x() * canvasMultiplier,
                        pos_y: e.target.y() * canvasMultiplier,
                        rotation: e.target.rotation(),
                    };
                    updateImageDimensions(imageIndex, dimensions);
                    imageRef.current.moveTo(containerRef.current);
                    imageRef.current.zIndex(currentDraggedIndex);
                }
            } }))) : null));
});
export default MovableImage;
